export const ColorsGame     = ['🔴', '🟠', '🟡', '🟢', '🔵', '🟣']
export const ColorBlack     = '⚫️'
export const ColorWhite     = '⚪️'
export const NumberOfColors = 4